module.exports = __webpack_public_path__ + "img/gilpin-hotel-&-lake-house-media-and-influencer-engagement.b24ee39e.png";